// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
let Assessment
import { getAPIURL } from "assessments/utils"
const QuestionCollection =
  require("assessments/models/question-collection").default
const AnswerCollection = require("assessments/models/answer-collection").default

export default Assessment = (function () {
  Assessment = class Assessment extends (
    require("lib/static-shim").default(require("lib/utils/model").default)
  ) {
    static initClass() {
      this.prototype.defaults = () => {
        // TODO: move this logic to admin
        return {
          type: "assessment",
          assessment_type: 1, // practice
          method: "assessment_editor"
        }
      }

      this.prototype.assessmentTypeOptions =
        require("./assessment-types").default
    }

    url() {
      let url = ""
      if (!this.isNew()) {
        url = `${this.id}`
      }
      url = getAPIURL(url, this)
      return url
    }

    initialize(attributes, options) {
      if (options == null) {
        options = {}
      }
      this.options = options
      ;`\
Options explanation:
  - isAdmin: Is this assessment being loaded from the admin?
  - isReview: Is this assessment being loaded in review mode (e.g. a teacher viewing a students results)?\
`
      _.defaults(this.options, {
        isAdmin: false,
        isReview: false
      })
      this.options.assessment = this

      this.answers = new AnswerCollection()
      this.questions = new QuestionCollection([], this.options)
      this._parseQA()
      return this.on("change:answers", this._parseQA)
    }

    _parseQA() {
      if (this.get("answers")) {
        this.answers.reset(this.get("answers"))
      }
      if (this.get("questions")) {
        return this.questions.reset(this.get("questions"))
      }
    }

    isCompleted() {
      return this.answers.length === this.questions.length
    }

    showRealtimeFeedback() {
      ;`\
Determines whether or not an assessment should 
show realtime feedback.
TODO: move to view layer?\
`
      const practiceMode = this.get("assessment_type") === 1
      return practiceMode || this.options.isReview
    }
  }
  Assessment.initClass()
  return Assessment
})()
